export default __webpack_public_path__ + "static/media/Path right black.7ae2bb4d.svg";